import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import { IHubDriver } from "interfaces/Hub";
import { Button } from "components/ui/ButtonGs";
import { useMutation, useQueryClient } from "react-query";
import { useHubDriver } from "hooks/api";
import { useErrorHandler } from "exceptions/ErrorHandler";
import { toast } from "sonner";
interface IDeleteProps {
  isOpen: boolean;
  data: IHubDriver;
  onClose: () => void;
}
export const HubDeleteDriver: React.FC<IDeleteProps> = ({
  isOpen,
  data,
  onClose,
}) => {
  const { deleteDriver } = useHubDriver();
  const { errorHandler } = useErrorHandler();
  const queryClient = useQueryClient();
  const mutation = useMutation(() => deleteDriver(data.id), {
    onSuccess: () => {
      queryClient.invalidateQueries("deleteDriver");
      toast.success("Motorista removida com sucesso");
      onClose();
    },
    onError: (error) => {
      errorHandler(error);
    },
  });

  const handleConfirm = () => {
    mutation.mutate();
  };
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-GilroyBold text-lg tracking-normal">
            Você tem certeza dessa exclusão?
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <article className="mb-4">
            Está é uma ação irreversível, caso você tenha certeza que deseja
            excluir o Motorista, clique no botão{" "}
            <span className="font-bold">Deletar</span>. Caso contrário, clique
            no botão <span className="font-bold">cancelar</span>.
          </article>
          <div className="bg-slate-100 p-4 border-slate-300 rounded-sm text-sm font-medium shadow-inner">
            Excluir: <span className="text-red-500">{data.name}</span>
          </div>
        </DialogDescription>
        <DialogFooter>
          <Button.Root size="sm" variant="secondary" onClick={onClose}>
            Cancelar
          </Button.Root>
          <Button.Root
            size="sm"
            variant="danger"
            onClick={() => handleConfirm()}
            disabled={mutation.isLoading}
          >
            Deletar
          </Button.Root>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
